import React from 'react';
import { DSTitleTypography } from '../../../../design-system/Typography';
import DSValueTypography from '../../../../design-system/Typography/DSValueTypography';
import DSBox from '../../../../design-system/DSBox';
import { Theme } from '../../../../types';
import useKlydoColorPickerModal from '../hooks/useKlydoColorPickerModal';
import DSLabelTypography from '../../../../design-system/Typography/DSLabelTypography';
import { ThemeStackStrings } from '../../../../types';
import ColorPickerButton from './ColorPickerButton';
import DSIconButton from '../../../../design-system/DSIconButton';
import { ReactComponent as TrashIcon } from '../../../../design-system/Icons/trashIcon.svg';

interface KlydoColorPickerModalProps {
  theme?: Theme;
  onThemeChange: (theme: Theme) => void;
  onChangeColor: (key: string, color: string) => boolean;
  selectedThemeIndex?: number;
  onDelete?: () => void;
}

const KlydoColorPickerModal: React.FC<KlydoColorPickerModalProps> = ({
  onThemeChange,
  theme,
  onChangeColor,
  selectedThemeIndex,
  onDelete,
}) => {
  const {
    spacing,
    updatedTheme,
    handleColorPick,
    handleColorChange,
    areColorsValid,
  } = useKlydoColorPickerModal({ theme, onChangeColor, onThemeChange });
  return (
    <DSBox
      sx={{
        width: spacing(65),
        backgroundColor: 'var(--background-paper-elevation-24, #383838)',
        boxShadow:
          '0px 9px 46px 8px rgba(0, 0, 0, 0.12), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 11px 15px -7px rgba(0, 0, 0, 0.20)',
        padding: spacing(3),
        borderRadius: 'var(--3, 24px)',
        display: 'flex',
        flexDirection: 'column',
        gap: spacing(1.5),
      }}
    >
      <DSTitleTypography>Create your own color palette</DSTitleTypography>
      {Object.keys(updatedTheme).map((key) => (
        <DSBox
          key={key}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <DSValueTypography
            color={
              areColorsValid[key as keyof typeof areColorsValid] === false
                ? 'red'
                : undefined
            }
          >
            {ThemeStackStrings[key as keyof typeof ThemeStackStrings]}
          </DSValueTypography>
          <DSLabelTypography>
            {areColorsValid[key as keyof typeof areColorsValid] === false
              ? 'Color contrast low. Try again'
              : ''}
          </DSLabelTypography>
          <ColorPickerButton
            color={updatedTheme[key as keyof Theme]}
            onColorClick={() => handleColorPick(key as keyof Theme)}
            onColorChange={handleColorChange}
          />
        </DSBox>
      ))}
      {selectedThemeIndex !== undefined && onDelete && (
        <DSBox sx={{ display: 'flex', justifyContent: 'flex-start' }}>
          <DSIconButton
            onClick={onDelete}
            sx={{
              color: 'text.secondary',
              '&:hover': {
                color: 'error.main',
              },
            }}
          >
            <TrashIcon />
          </DSIconButton>
        </DSBox>
      )}
    </DSBox>
  );
};

export default KlydoColorPickerModal;
